import { Link } from "react-router-dom";
import popularesImg from "../../assets/blog/popularesImg.jpg";
import { blogArticles as defaultArticles, blogCategories as defaultCategories } from "../../data/blogContent";

const Populares = ({
  highlight,
  articles = defaultArticles,
  basePath = "/blog",
  categories = defaultCategories,
}) => {
  const popularArticle =
    highlight ||
    articles
      .slice()
      .sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt))[0];

  const category = popularArticle ? categories[popularArticle.category] : null;

  if (!popularArticle || !category) {
    return null;
  }

  return (
    <section className="relative my-14 sm:my-20">
      <img
        src={popularesImg}
        alt="Artículo destacado"
        className="w-full h-80 sm:h-[420px] lg:h-[480px] object-cover rounded-3xl sm:rounded-[48px]"
      />
      <div className="absolute inset-0 rounded-3xl sm:rounded-[48px] bg-gradient-to-r from-[#0f1a49] via-[#0f1a49]/85 to-transparent" />
      <div className="absolute inset-0 flex items-end sm:items-center">
        <div className="max-w-3xl px-6 sm:px-14 py-10 text-white space-y-4 text-center sm:text-left">
          <span className="inline-flex items-center gap-2 px-4 py-1 rounded-full bg-white/15 text-xs sm:text-sm font-semibold uppercase tracking-wide mx-auto sm:mx-0">
            {category.title}
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight">
            {popularArticle.title}
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-white/90 leading-relaxed max-w-2xl mx-auto sm:mx-0">
            {popularArticle.excerpt}
          </p>
          <div className="flex flex-wrap items-center justify-center sm:justify-start gap-4 text-xs sm:text-sm text-white/70 font-medium">
            <span>{popularArticle.author}</span>
            <span className="hidden sm:inline">•</span>
            <span>{popularArticle.date}</span>
            <span className="hidden sm:inline">•</span>
            <span>{popularArticle.readTime}</span>
          </div>
          <Link
            to={`${basePath}/${popularArticle.category}/${popularArticle.slug}`}
            className="inline-flex items-center gap-3 bg-white text-blue-700 font-semibold px-6 py-3 rounded-full shadow-lg hover:shadow-xl hover:bg-blue-50 transition-all duration-150 mx-auto sm:mx-0"
          >
            Leer artículo destacado
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 5l7 7-7 7"
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Populares;
